import React, { useState, useEffect } from "react";
import { Box, Accordion, AccordionSummary, Typography, AccordionDetails, CircularProgress } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { detailparcelleStyles } from "./styles";
import jwtInterceptor from "../../../service/jwtInterceptor";
import { useApplication } from "../../../hooks/UseApplication";
import { API_URL } from "@utils/constants";
import { useTransactionsAndFaos } from "../../../Context/crm/TransactionsAndFaosContext";
import {ListExpandable} from "../../../static/ListExpandable";

const TransactionDetail = () => {
    const { setTransactions, transactions } = useTransactionsAndFaos();
    const generalId = useApplication();
    const gId = generalId.details.old_lands_id;
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState('panel1');

    const handleChanges = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            if (!gId) return;
            const response = await jwtInterceptor.get(`${API_URL}/transaction/land/${gId}`);
            const data = response.data?.data ?? [];
            setTransactions(data);
        } catch (error) {
            console.error("❌ Erreur lors de la requête API :", error);
        } finally {
            setLoading(false);
        }
    };

    const formatPrice = (price) => {
        if (typeof price !== "number") return price;
        return price.toLocaleString("fr-FR", { minimumFractionDigits: 0 });
    };

    useEffect(() => { fetchData(); }, [gId]);
    useEffect(() => { setLoading(false); }, [transactions]);

    const renderTransactionsJsx = () => {
        if(loading){
            return <CircularProgress />
        }
        if(transactions.length > 0){
            return transactions.map((transaction) => {
                        return(
                            <Accordion
                            key={transaction.old_new_transactions_id}
                            expanded={expanded === transaction.old_new_transactions_id}
                            onChange={handleChanges(transaction.old_new_transactions_id)}
                        >
                            <AccordionSummary
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                                expandIcon={<ExpandMoreIcon />}
                                sx={detailparcelleStyles.accordions}
                            >
                                <Typography sx={{ width: "33.3%", textAlign: "start", ml: 5, color: "#0D0D0D", fontWeight: "bold" }}>
                                    Acheteur(s) : {transaction.acquereur}
                                </Typography>
                                <Typography sx={{ width: "33.3%", textAlign: "right", color: "#0D0D0D", fontWeight: "bold" }}>
                                    {transaction.date}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ background: "#FAFAFA" }}>
                                <Box className="col-12">
                                <AccordionDetails sx={{ background: "#FAFAFA" }}>
                                    <Box className="col-12">
                                        <Box className="d-flex justify-content-between" sx={{...detailparcelleStyles.grayBg , ...detailparcelleStyles.flexWrapMobile, ...detailparcelleStyles.responsivePaddingCell}}>
                                            <Box className="mx-2 w-50" sx={{...detailparcelleStyles.w100mobile}}>
                                                <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Identification : </span> {transaction.numero_requete}</p>
                                                <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Ville :</span> {transaction.commune}</p>
                                                <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Adresse :</span> <br />{transaction.commune_lieu}</p>
                                            </Box>
                                            <Box className="mx-2 w-50" sx={{...detailparcelleStyles.w100mobile}}>
                                            <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Acheteurs :</span> {transaction.acquereur}</p>
                                                <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Vendeurs :</span> {transaction.requerant_proprietaire}</p>
                                                <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Prix : </span> {transaction.prix_vente ? `${formatPrice(transaction.prix_vente)} CHF` : 'N/A'}</p>
                                                <p><span style={{ color: detailparcelleStyles.graylight, ...detailparcelleStyles.fontWeightTitle }}>Détails :</span> <br />{transaction.objet}</p>
                                            </Box>
                                        </Box>
                                    </Box>
                                </AccordionDetails>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
    
                        )
                    })
        }
        return <Typography variant="body1">Pas de transaction disponible</Typography>;
    };

    return (
        <Box className="Layout bg-white my-4 rounded p-4" id="transaction">
            <Typography variant="h6" style={detailparcelleStyles.fontWeightTitle}>TRANSACTIONS</Typography>
            <Box sx={{ p: 1, mt: 2 }}>
                {renderTransactionsJsx()}
            </Box>
        </Box>
    );
};

export default TransactionDetail;